
<template>
    <div>
		<div class="row">
			<div class="col-10 mb-4">
				<h1>{{ $t("curriculum-mapping") }}</h1>
			</div>
            <div class="col-2 mb-4" v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')">
                <button class="btn btn-primary float-right" v-if="!new_root" @click="new_root = true;">{{ $t('new') }}</button>
                <button class="btn btn-danger float-right" v-else @click="new_root = false;">{{ $t('cancel') }}</button>
            </div>
		</div>
		<div class="row">
			<div class="col-md-8">
                <div v-if="new_root" class="card mb-2">
                    <h4 class="card-header">{{ $t('new-curriculum') }}</h4>
                    <div class="card-body">
                        <TextInput :label="$t('title')" v-model="node.title">
                        </TextInput>
                        <TextAreaInput :label="$t('notes')" v-model="node.note"></TextAreaInput>
                        <button class="btn btn-secondary float-right" @click="saveRoot" :disabled="!node.title">{{ $t('add') }}</button>
                    </div>
                </div>
				<Table
					:loading="loading"
					:submitting="submitting"
					:cols="[
						{ key: 'title', heading: $t('name'), size: 3, sortable: false }
					]"
					:data="curricula"
					breakpoint="md"
					:filters="{
						...filters,
						page: filters.page,
						page_size: filters.page_size,
						total: total,
					}"
               		:searchable="true"
                	:scrollPaginate="true"
					@refresh="refresh"
					@selectItem="curriculummap => $router.push(`/curriculum-mapping/node/${curriculummap.id}/graph`)"
                    :allowRightClick="true"
                    @deleteItem="openDeleteDialog"
				>
					<!-- Table Header -->
					<template v-slot:header>
					</template>
				</Table>
			</div>

			<div class="col-md-4">
				<div class="list-group border-radius-2 no-border mb-3">
                    <router-link to="/curriculum-mapping/components" class="list-group-item" v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')">{{ $t('components') }}</router-link>
					<router-link to="/curriculum-mapping/learning-outcomes" class="list-group-item">{{ $t('learning-outcomes') }}</router-link>
					<router-link to="/curriculum-mapping/learning-outcomes/unmapped" class="list-group-item">{{ $t('unmapped-learning-outcomes') }}</router-link>
					<router-link to="/curriculum-mapping/learning-outcomes/report" class="list-group-item">{{ $t('learning-outcomes-report') }}</router-link>
				</div>
			</div>
		</div>
    </div>
</template>
<script>
import Table from "src/components/Table/Table.vue";

export default {
	components: {
        Table,
	},
    data() {
        return {
        	total: 0 ,
            filters: {
                page: 1,
                page_size: 30,
                search: '',
                sort: '',
                order: '',
            },
            loading: true,
            submitting: false,
            curricula: [],
            curriculummaps: [],
            new_root: false,
            node:{}
        }

    },
    mounted() {
        this.listCurricula();
    },
    methods: {
        listCurricula() {
            if (this.submitting) return;
            this.submitting = true;
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/listroots`,{
                method: "post",
                data: this.filters
            })
            .then((res) => {
				if (res.status === "SUCCESS") {
                    this.curricula=res.results;
            		this.loading = false;
                	this.filters.page = res.pagination.page
                	this.filters.page_size = res.pagination.page_size
                	this.total = res.pagination.total
				} else {
					this.$log.info.call(this, status)
				}
            	this.submitting = false;
			}).catch(error => {
            	this.submitting = false;
				this.$log.error.call(this, error);
			});
        },
        refresh(filters) {
            this.filters = { ...this.filters, ...filters }
            this.listCurricula()
        },
        saveRoot(){
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/save`,{
                method: "post",
                data: this.node
            })
            .then((res) => {
				if (res.status === "SUCCESS") {
                    this.listCurricula()
                    this.new_root = false
				} else {
					this.$log.info.call(this, status)
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
        },
        openDeleteDialog(item) {
            this.selectedItem = item;

            this.$store.commit('openDialog', {
                title: this.$t('are-you-sure'),
                content: this.$t('delete-{e}-warning',{e: this.$t('curriculum')}),
                cancelBtn: true,
                confirmCallBack: this.removeItem,
            })
        },
        removeItem() {
            if (!this.selectedItem) return ;
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/delete`, {
                method: 'POST',
                data: { 
                    id: this.selectedItem.id 
                }
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error deleting curriculum')
                this.curricula = this.curricula.filter(el => el.id !== this.selectedItem.id)
            }).catch(err => {
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-delete-{e}',{e:this.$t('curriculum')}),
                })
            }).finally(() => {
                this.selectedItem = undefined
            })
        }
    },
    computed: {
    }
};
</script>
